import React, { useEffect, useState, useCallback } from "react";
import GearIcon from "components/ui/icons/svgs/GearIcon";

const MaintenanceNotice = ({ time = 0, message, title, game }) => {
  const [playGame, setPlayGame] = useState(false);
  const [difference, setDifference] = useState("");
  useEffect(() => {
    setInterval(() => {
      formatRemainingTime(time);
    }, 1000);
    return () => clearInterval(1000);
  }, []);

  // Calculate hours and minutes from remaining seconds
  const formatRemainingTime = (dateWithTime) => {
    const [datePart, timePart] = dateWithTime.split(",").map((str) => str.trim());

    // Parse the date as IST (UTC+05:30)
    const targetDateTime = new Date(`${datePart}T${timePart}+05:30`);

    const now = new Date();
    let diffInSeconds = Math.floor((targetDateTime - now) / 1000);

    if (diffInSeconds < 0) diffInSeconds = 0;

    const hours = Math.floor(diffInSeconds / 3600);
    const minutes = Math.floor((diffInSeconds % 3600) / 60);
    const seconds = diffInSeconds % 60;

    const parts = [];
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0 || hours > 0) parts.push(`${minutes}m`);
    parts.push(`${seconds}s`);
    setDifference(parts.join(" "));
    return parts.join(" ");
  };

  return (
    <div
      // className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 to-gray-700 text-white px-4"
      className="min-h-screen bg-white flex items-center justify-center"
      style={{
        height: "100vh",
        width: "100vw",
        // backgroundColor: '#f0f0f0',
        backgroundColor: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <style>
        {`
          @keyframes rotate-clockwise {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          @keyframes rotate-counterclockwise {
            from { transform: rotate(0deg); }
            to { transform: rotate(-360deg); }
          }
          .gear-1 {
            animation: rotate-clockwise 3s linear infinite;
          }
          .gear-2 {
            animation: rotate-counterclockwise 2s linear infinite;
          }
          .gear-3 {
            animation: rotate-clockwise 2.5s linear infinite;
          }
        `}
      </style>
      <div className="text-center flex flex-col items-center justify-center">
        <img src="/icons/Carrum_mv.svg" alt="carrum logo" className="w-[100px] h-[100px]" />
        {!playGame && <h1 className="text-3xl font-bold mb-2 mt-2">{title}</h1>}
        {!playGame && <h2 className="text-[#6a7280] ">{message}</h2>}

        {!playGame && (
          <div className="flex w-[120px] justify-center items-center mt-3 gap-1 mb-2">
            <p
              style={{ borderRadius: "50%" }}
              className="flex justify-center items-center gear-1 p-0 w-[30px] h-[30px]"
            >
              <GearIcon size={48} color="#6a7280"></GearIcon>
            </p>
            <p
              style={{ borderRadius: "50%" }}
              className="flex justify-center items-center gear-2 p-0 w-[30px] h-[30px]"
            >
              <GearIcon size={48} color="#6a7280"></GearIcon>
            </p>
            <p
              style={{ borderRadius: "50%" }}
              className="flex justify-center items-center gear-3 p-0 w-[30px] h-[30px]"
            >
              <GearIcon size={48} color="#6a7280"></GearIcon>
            </p>
          </div>
        )}
        {time !== "" && (
          <p
            style={{ borderRadius: "20px", color: "black" }}
            className="text-[#6a7280] shadow-lg w-fit px-4 py-2 bg-gray-300 mt-4"
          >
            {difference !== "0s" && `Will be back in : ${difference}`}
            {difference === "0s" && "Maintenance Completed Try To Refresh!"}
          </p>
        )}
        {!playGame && game === "true" && (
          <h1 className="mt-4">
            <span
              className="text-blue-500 underline cursor-pointer"
              onClick={() => setPlayGame(true)}
            >
              Play
            </span>{" "}
            🐍 game while you wait!
          </h1>
        )}
        {playGame && <SnakeGame onBack={() => setPlayGame(false)} />}
      </div>
    </div>
  );
};
const SnakeGame = ({ onBack = () => {} }) => {
  const BOARD_SIZE = 20;
  const INITIAL_SNAKE = [{ x: 10, y: 10 }];
  const INITIAL_FOOD = { x: 5, y: 5 };
  const INITIAL_DIRECTION = { x: 1, y: 0 }; // Start moving right instead of stationary

  const [snake, setSnake] = useState(INITIAL_SNAKE);
  const [food, setFood] = useState(INITIAL_FOOD);
  const [direction, setDirection] = useState(INITIAL_DIRECTION);
  const [gameRunning, setGameRunning] = useState(false);
  const [score, setScore] = useState(0);
  const [gameOver, setGameOver] = useState(false);

  // Generate random food position
  const generateFood = useCallback(() => {
    let newFood;
    do {
      newFood = {
        x: Math.floor(Math.random() * BOARD_SIZE),
        y: Math.floor(Math.random() * BOARD_SIZE),
      };
    } while (snake.some((segment) => segment.x === newFood.x && segment.y === newFood.y));
    return newFood;
  }, [snake]);

  // Move snake
  const moveSnake = useCallback(() => {
    if (!gameRunning || gameOver) return;

    setSnake((currentSnake) => {
      const newSnake = [...currentSnake];
      const head = {
        x: newSnake[0].x + direction.x,
        y: newSnake[0].y + direction.y,
      };

      // Check wall collision
      if (head.x < 0 || head.x >= BOARD_SIZE || head.y < 0 || head.y >= BOARD_SIZE) {
        setGameOver(true);
        setGameRunning(false);
        return currentSnake;
      }

      // Check self collision - only check against body segments, not head
      if (newSnake.some((segment) => segment.x === head.x && segment.y === head.y)) {
        setGameOver(true);
        setGameRunning(false);
        return currentSnake;
      }

      newSnake.unshift(head);

      // Check food collision
      if (head.x === food.x && head.y === food.y) {
        setScore((prev) => prev + 1);
        setFood(generateFood());
      } else {
        newSnake.pop();
      }

      return newSnake;
    });
  }, [direction, food, gameRunning, gameOver, generateFood]);

  // Game loop
  useEffect(() => {
    if (gameRunning) {
      const gameInterval = setInterval(moveSnake, 150);
      return () => clearInterval(gameInterval);
    }
  }, [moveSnake, gameRunning]);

  // Handle keyboard input
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (!gameRunning) return;

      switch (e.key) {
        case "ArrowUp":
          if (direction.y !== 1) {
            // Prevent moving down when going up
            setDirection({ x: 0, y: -1 });
          }
          break;
        case "ArrowDown":
          if (direction.y !== -1) {
            // Prevent moving up when going down
            setDirection({ x: 0, y: 1 });
          }
          break;
        case "ArrowLeft":
          if (direction.x !== 1) {
            // Prevent moving right when going left
            setDirection({ x: -1, y: 0 });
          }
          break;
        case "ArrowRight":
          if (direction.x !== -1) {
            // Prevent moving left when going right
            setDirection({ x: 1, y: 0 });
          }
          break;
        default:
          return;
      }

      e.preventDefault();
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [direction, gameRunning]);

  // Start game
  const startGame = () => {
    setSnake(INITIAL_SNAKE);
    setFood(INITIAL_FOOD);
    setDirection(INITIAL_DIRECTION);
    setScore(0);
    setGameOver(false);
    setGameRunning(true);
  };

  // Stop game
  const stopGame = () => {
    setGameRunning(false);
  };

  // Reset game
  const resetGame = () => {
    setSnake(INITIAL_SNAKE);
    setFood(INITIAL_FOOD);
    setDirection(INITIAL_DIRECTION);
    setScore(0);
    setGameOver(false);
    setGameRunning(false);
  };

  return (
    <div className="flex flex-col items-center p-4 bg-transparent rounded-lg  max-w-md mx-auto">
      {/* Game Title */}
      {/* <h2 className="text-xl font-bold text-gray-800 mb-3">Snake Game</h2> */}

      {/* Score */}
      <div className="mb-3">
        <span className="text-lg font-semibold text-gray-600">Score: {score}</span>
      </div>

      {/* Game Board */}
      <div
        style={{ borderWidth: "1px" }}
        className="relative bg-white border-gray-400 rounded-lg mb-4"
      >
        <div
          className="grid gap-0 p-2"
          style={{
            gridTemplateColumns: `repeat(${BOARD_SIZE}, 12px)`,
            gridTemplateRows: `repeat(${BOARD_SIZE}, 12px)`,
            width: `${BOARD_SIZE * 12 + 16}px`,
            height: `${BOARD_SIZE * 12 + 16}px`,
          }}
        >
          {/* Render game board */}
          {Array.from({ length: BOARD_SIZE * BOARD_SIZE }).map((_, index) => {
            const x = index % BOARD_SIZE;
            const y = Math.floor(index / BOARD_SIZE);

            const isSnakeHead = snake[0]?.x === x && snake[0]?.y === y;
            const isSnakeBody = snake
              .slice(1)
              .some((segment) => segment.x === x && segment.y === y);
            const isFood = food.x === x && food.y === y;

            let cellClass = "w-3 h-3 ";

            if (isSnakeHead) {
              cellClass += "bg-gray-600 rounded-sm";
            } else if (isSnakeBody) {
              cellClass += "bg-gray-400 rounded-sm";
            } else if (isFood) {
              cellClass += "bg-gray-500 rounded-full";
            } else {
              cellClass += "bg-gray-100";
            }

            return <div key={index} className={cellClass} />;
          })}
        </div>

        {/* Game Over Overlay */}
        {gameOver && (
          <div className="absolute inset-0 bg-black bg-opacity-75 flex items-center justify-center rounded-lg h">
            <div className="text-center text-white">
              <div className="text-2xl font-bold mb-2">Game Over!</div>
              <div className="text-lg mb-3 text-gray-400">Final Score: {score}</div>
            </div>
          </div>
        )}
      </div>

      {/* Game Control Buttons */}
      <div className="flex gap-2 mb-3">
        <button
          style={{ borderWidth: "1px" }}
          onClick={onBack}
          className="bg-transparent  text-gray-500 border border-gray-500 font-bold py-0 px-4 rounded hover:text-gray-600 hover:border-gray-600"
        >
          Back
        </button>
        {!gameRunning && !gameOver && (
          <button
            style={{ borderWidth: "1px" }}
            onClick={startGame}
            className="bg-transparent  text-green-500 border border-green-500 font-bold py-0 px-4 rounded hover:text-green-600 hover:green-gray-600"
          >
            Start
          </button>
        )}

        {gameRunning && (
          <button
            style={{ borderWidth: "1px" }}
            onClick={stopGame}
            className="bg-transparent  text-red-500 border border-red-500 font-bold py-0 px-4 rounded hover:text-red-600 hover:green-red-600"
          >
            Stop
          </button>
        )}
        {gameOver && (
          <button
            style={{ borderWidth: "1px" }}
            onClick={startGame}
            className="bg-transparent  text-green-500 border border-green-500 font-bold py-0 px-4 rounded hover:text-green-600 hover:green-gray-600"
          >
            Play Again
          </button>
        )}
        <button
          style={{ borderWidth: "1px" }}
          onClick={resetGame}
          className="bg-transparent  text-gray-500 border border-gray-500 font-bold py-0 px-4 rounded hover:text-gray-600 hover:border-gray-600"
        >
          Reset
        </button>
      </div>

      {/* Instructions */}
      {/* <div className="text-center text-sm text-gray-600">
        <div className="mb-1">Use arrow keys to control the snake</div>
        <div>Eat red food to grow and increase score!</div>
      </div> */}
    </div>
  );
};
export default MaintenanceNotice;
